<template>
    <div class="iframe-container">
        <iframe id="pdf_previewer_iframe"
                :src="src"
                style="height: 100%; width: 100%;"
                frameborder="0">
        </iframe>
        <div class="loader" v-if="status === 'loading'"></div>
    </div>
</template>

<script>

import {getTemplatePreviewPdf} from "../../helpers/requests/RequestsPDFs";
import router from "../../router";
import {getExpedient} from "../../helpers/requests/RequestsExpedients";
import {getTemplate} from "../../helpers/requests/RequestsTemplates";

export default {
    name: "PdfPreview",
    components: {},
    props: {},
    data() {
        return {
            expedient: {},
            template: {},
            src: '',
            status: 'loading',
        }
    },
    beforeMount() {
        document.getElementById('top').classList.add('d-none');
        document.getElementsByClassName('container-fluid')[1].classList.remove('container-fluid');
    },
    async mounted() {
        await this.loadExpedient();
        await this.loadTemplate();
        await this.loadPdf();

    },
    methods: {
        async loadExpedient() {
            this.expedient = await getExpedient(router.currentRoute.value.params.expedient);
        },
        async loadTemplate() {
            this.template = await getTemplate(router.currentRoute.value.params.template);
        },
        async loadPdf() {
            this.status = 'loading';

            let query_parameters = router.currentRoute.value.query;

            let params = {
                client: this.expedient.clients[0].id,
                entity: this.expedient.entities[0].id,
                template: router.currentRoute.value.params.template,
                expedient: this.expedient.id,

                highlight: !!query_parameters.highlight,
                parse: !!query_parameters.parse,
                download: !!query_parameters.download,
            }
            if (this.expedient.lawyers.length > 0) {
                params.lawyer = this.expedient.lawyers[0].id;
            }
            if (this.expedient.attorneys.length > 0) {
                params.attorney = this.expedient.attorneys[0].id;
            }

            // TODO: Receive url query parameters to be used in shortcode processing
            let pdf_content = await getTemplatePreviewPdf(params);
            this.src = "data:application/pdf;base64," + escape(pdf_content);

            this.status = 'loaded';
        }
    },
    setup() {
        return {}
    }
}
</script>

<style scoped>


main {
    padding-top: 0;
    overflow: hidden;
}

.iframe-container {
    position: absolute;
    top: 0;
    height: 100vh;
    width: 100%;
    /*background-color: rgba(50, 54, 57, 255);*/
    background-color: rgba(82, 86, 89, 255);
    z-index: 9999999;
}

.iframe-container iframe {
    z-index: 99999999999999;
    overflow: hidden;
}

.loader {
    z-index: 9999999999999999;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
}
</style>
